import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared';

import { KPIPipe, KPISiglaPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        KPIPipe,
        KPISiglaPipe
    ],
    exports: [
        KPIPipe,
        KPISiglaPipe
    ],
    providers: [
        KPIPipe,
        KPISiglaPipe
    ]
})
export class KPIsModule { }
